import {Component, Output, EventEmitter} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SequenceItem} from '../../parks/park/custom-sequences/park-custom-sequences.component';

@Component({
  templateUrl: './park-custom-sequence-form.html',
  styleUrls: ['./park-custom-sequence-form.css'],
  selector: 'park-custom-sequence-form'
})

export class ParkCustomSequenceFormComponent {
  @Output() addCustomSequence = new EventEmitter<SequenceItem>();

  private modalReference: any;
  public newCustomSequenceForm: FormGroup;

  constructor(private modalService: NgbModal) {
    this.newCustomSequenceForm = new FormGroup({
      nm: new FormControl('', Validators.required),
    });
  }

  open(content) {
    this.modalReference = this.modalService.open(content, {windowClass: 'gray-modal', centered: true});
  }
  
  addSequence(form) {
    if (form.value.nm && form.valid) {
      this.addCustomSequence.emit({
        sequenceId: '',
        nm: form.value.nm
      });
    }

    this.modalReference.close();
    form.reset();
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/forms/park-custom-sequence-form/park-custom-sequence-form.component.ts